import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Popconfirm, Space, notification, Image } from "antd";
import { useState } from "react";
import { NotificationService } from "../../services/NotificationService";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import Create from "./Create";
import EditMember from "./../member/EditMember";

export default function Notification() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [editRecordUser, setEditRecordUser] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Picture',
            align: 'center',
            dataIndex: 'picture',
            key: 'picture',
            render: (value, record) => {
                return value ? <Image src={value?.fullpath} width={50}/> : 'No Image'
            },
        },
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Subject',
            align: 'center',
            dataIndex: 'subject',
            key: 'subject',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'TYPE',
            align: 'center',
            dataIndex: 'noti_type',
            key: 'noti_type',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Description',
            align: 'center',
            dataIndex: 'description',
            key: 'description',
            render: (value, record) => {
                return value
            },
        },
        { 
            title: 'Send to',
            align: 'center',
            dataIndex: 'type',
            key: 'type',
            render: (value, record) => {
                return value == 'all' ? 'All Users' : <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser(record.recipient)
                        setIsModalOpenUser(true)
                    }}>{record?.recipient?.id} {record?.recipient?.full_name}</div>
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        {/* <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div> */}

                        <Popconfirm
                            placement="left"
                            title="Delete this notification"
                            description="You cannot rollback this notification."
                            okText="Yes"
                            cancelText="No"
                            onConfirm={(e) => {
                                onDelete(record.id)
                            }}
                        >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </Popconfirm>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await NotificationService.getNotifications(payload)
        return res
    }

    const onDelete = async (id: number) => {
        const res = await NotificationService.deleteNotification(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <Create
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></Create>
            </Modal>
            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Notification',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Notification"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
